import { render } from "./company-logo.vue?vue&type=template&id=28a56084&scoped=true"
import script from "./company-logo.vue?vue&type=script&lang=js"
export * from "./company-logo.vue?vue&type=script&lang=js"

import "./company-logo.vue?vue&type=style&index=0&id=28a56084&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a56084"]])

export default __exports__